;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:propstrata-app":true});}catch(e){}}();import {
	type UpdateNotificationSchema,
	type UpdateUserNotificationStatusSchema,
	updateNotificationSchema,
	updateUserNotificationStatusSchema,
} from "@/lib/schema/notification";

import { logger } from "@/lib/services/logger";
import { queryFetcher } from "@/queries/config/query-fetcher";

export async function updateNotificationPreferences(
	data: UpdateNotificationSchema,
): Promise<{ notificationSetting: { emailEnabled: boolean } }> {
	// Lets validate the data
	const validationResult = updateNotificationSchema.safeParse(data);

	if (!validationResult.success) {
		logger.error(
			"Error updating user notification preferences",
			validationResult.error,
			{
				data,
			},
		);

		throw new Error("Error updating your notification preferences");
	}

	return queryFetcher("/api/users/notification", {
		body: JSON.stringify(validationResult.data),
		method: "PUT",
	});
}

export async function updateUserNotificationStatus(
	data: UpdateUserNotificationStatusSchema,
) {
	const validationResult = updateUserNotificationStatusSchema.safeParse(data);

	if (!validationResult.success) {
		logger.error("Error updating notification", validationResult.error, {
			data,
		});

		throw new Error("Error updating notification");
	}

	const promises = [];
	const notificationsWithWorkflows = validationResult.data.ids.filter(
		(id) => id.workflowId || id.subscriberId,
	);
	const userNotifications = validationResult.data.ids.filter(
		(id) => !id.workflowId && !id.subscriberId,
	);

	if (userNotifications.length > 0) {
		promises.push(
			queryFetcher("/api/users/notifications", {
				body: JSON.stringify({
					notificationIds: userNotifications.map((id) => id.id),
					status: validationResult.data.status,
				}),
				method: "PUT",
			}),
		);
	}

	if (notificationsWithWorkflows.length > 0) {
		promises.push(
			queryFetcher("/api/notifications", {
				body: JSON.stringify({
					ids: notificationsWithWorkflows.map((id) => id.id),
					status: validationResult.data.status,
				}),
				method: "PUT",
			}),
		);
	}

	const [result] = await Promise.all(promises);

	return result;
}
